import WrappedLink from './wrapped-link';
import Link from 'next/link';
import JobSearchForm from './forms/job-search-form';
import { primaryNav, secondaryNav } from '../data/nav';
import MobileNav from './mobile-nav';

const CrNav = ({ linkHighlight }) => {
  return (
    <header id="site-header" role="banner">
      <WrappedLink className="skip-link sr-only" href="#site-main">
        Skip to content
      </WrappedLink>
      <MobileNav />
      <div className="container-xl">
        <Link href="/" passHref>
          <a className="logo" aria-label="College Recruiter">
            <span className="sr-only">College Recruiter</span>
          </a>
        </Link>
        <div className="nav-container-top" id="cr-navbar">
          <JobSearchForm />

          <nav id="secondary-nav">
            <ul>
              {secondaryNav.map((p, i) => {
                return (
                  <li key={i} className={linkHighlight == p.linkID ? 'current' : ''}>
                    <Link passHref href={p.url}>
                      {p.linkText}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>

      <div className="header-bottom">
        <div className="container-xl">
          <nav id="primary-nav">
            <ul>
              {primaryNav.map((p, i) => {
                return (
                  <li key={i} className={linkHighlight == p.linkID ? 'current' : ''}>
                    <Link passHref href={p.url}>
                      {p.linkText}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
          {/* <div>
            Site Search
            <button
              onClick={toggleMobileNav}
              data-toggle="collapse"
              data-target="#cr-navbar"
              aria-controls="cr-navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
              className="search-toggler fa-regular fa-magnifying-glass"
              type="button"
            >
              <span className="sr-only">Search Toggle</span>
            </button>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default CrNav;
